import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Component } from 'react';

//  Non trasformare in pure function
class Divider extends Component {
    render() {
        const _a = this.props, { children, notifica, additionalData, isSelected } = _a, others = __rest(_a, ["children", "notifica", "additionalData", "isSelected"]);
        return (jsx("li", Object.assign({ className: "select__divider" }, others, { value: "", children: children })));
    }
}
Divider.defaultProps = {
    additionalData: null,
    children: null,
    isSelected: false,
    notifica: null,
};

export { Divider as default };
